<template>
  <v-app class="torilive-app">

    <v-content>
      <home></home>
    </v-content>

    <!--<toast></toast>-->
    <!--<confirm></confirm>-->

  </v-app>
</template>
<style lang="stylus">

  @import '~vuetify/src/stylus/settings/_variables.styl'

  body, .torilive-app
    background-color black !important

  h2
    font-weight 400
    font-size 1.3em
    @media $display-breakpoints.sm-and-up
      font-size 1.5em

</style>
<script>

  // import Toast from './components/common/Toast'
  // import Confirm from './components/common/Confirm'

  import Home from './views/Home'

  export default {
    name: 'App',

    components: {
      Home,
      // Toast,
      // Confirm,
    },

  }

</script>
